import Icon from '../components/Icon.vue'

Icon.register({
  mitten: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M368 416H48C39.2 416 32 423.2 32 432V496C32 504.8 39.2 512 48 512H368C376.8 512 384 504.8 384 496V432C384 423.2 376.8 416 368 416zM425 206.9C397.8 184.3 357.5 187.9 334.9 215.1L314 240.1 284.4 111.7C266.4 34.2 189-14.2 111.6 3.7 34.2 21.6-14.2 98.9 3.7 176.4L51.6 384H360.6L433.1 297C455.8 269.8 452.1 229.5 425 206.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mitten.js
// module id = TKgn
// module chunks = 144